'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var AccessController =
/*#__PURE__*/
function () {
  function AccessController() {
    _classCallCheck(this, AccessController);

    this._access = {
      admin: [],
      write: [],
      read: [] // Not used atm

    };
  }
  /* Overridable functions */


  _createClass(AccessController, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(address) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function load(_x) {
        return _load.apply(this, arguments);
      };
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function save() {
        return _save.apply(this, arguments);
      };
    }()
    /* Properties */

  }, {
    key: "add",

    /* Public Methods */
    value: function add(access, key) {
      // if(!Object.keys(this._access).includes(access))
      //   throw new Error(`unknown access level: ${access}`)
      // if (!this._access[access].includes(key))
      //   this._access[access].push(key)
      // TODO: uniques only
      switch (access) {
        case 'admin':
          this._access.admin.push(key);

          break;

        case 'write':
          this._access.write.push(key);

          break;

        case 'read':
          this._access.read.push(key);

          break;

        default:
          break;
      }
    }
  }, {
    key: "remove",
    value: function remove(access, key) {
      var without = function without(arr, e) {
        var reducer = function reducer(res, val) {
          if (val !== key) res.push(val);
          return res;
        };

        return arr.reduce(reducer, []);
      }; // if(!Object.keys(this._access).includes(access))
      //   throw new Error(`unknown access level: ${access}`)
      // if (this._access[access].includes(key))
      //   this._access[access] = without(this._access[access], key)


      switch (access) {
        case 'admin':
          this._access.admin = without(this._access.admin, key);
          break;

        case 'write':
          this._access.write = without(this._access.write, key);
          break;

        case 'read':
          this._access.read = without(this._access.read, key);
          break;

        default:
          break;
      }
    }
  }, {
    key: "admin",
    get: function get() {
      return this._access.admin;
    }
  }, {
    key: "write",
    get: function get() {
      // Both admins and write keys can write
      return this._access.write.concat(this._access.admin);
    } // Not used atm

  }, {
    key: "read",
    get: function get() {
      return this._access.read;
    }
  }]);

  return AccessController;
}();

module.exports = AccessController;